import React from "react";
import { FormQuestionDto } from "@green0meter/api-client";
import { SortableContainer } from "react-sortable-hoc";

import SortableItem from "../SortableItem";

import { Stack } from "@components/base";

const SortableList = SortableContainer<{ items: FormQuestionDto[] }>(
  ({ items }: { items: FormQuestionDto[] }) => {
    return (
      <Stack spacing={1}>
        {items.map((value, index) => (
          <SortableItem key={`item-${index}`} index={index} value={value} />
        ))}
      </Stack>
    );
  },
);

export default SortableList;
